import { trackEvent } from "src/Amplitude";
import { Box, Modal, Typography, Divider, Stack, Button, useTheme } from "@mui/material";
import React, { useEffect, useReducer, useState } from "react";
import api from "src/store/features/api";
import { formatCurrency } from "src/utils/helpers/PriceAndUnitsHelpers";
import TargetOrderCancelExecuteSummery from "./TargetOrderCancelExecuteSummery";

interface CancelProps {
  open: boolean;
  cancelReq: any;
  refetchData: any;
  handleClose: React.Dispatch<React.SetStateAction<boolean>>;
  handleOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const TargetOrderCancel = (props: CancelProps) => {
  const { open, handleClose, cancelReq, refetchData } = props;

  // -----------------------------STYLES------------------------
  const theme = useTheme();
  // -----------------------------REDUX------------------------
  const [triggerCancel] = api.useRequestCancelMutation();
  const { data: user } = api.useGetUserDatav2Query();
  // -----------------------------STATW------------------------
  const [cancelSummery, setCancelSummery] = useState(true);
  const [handleCancelReq, setHandleCancelReq] = useState(false);
  const [cancelCtSuccess, toggleCancelCtSuccess] = useReducer((isSuccess) => !isSuccess, false);
  // -----------------------------CONSTS------------------------
  const TITLE = "Request to Cancel Target";
  const BROKER_NAME = user ? user?.broker.name.split(" ").slice(0, -1) : "";
  const USER_NAME = user?.details.name;
  const BROKER_IMG = user?.broker.imgUrl;
  const BROKER_EMAIL = user?.broker.email;
  let customerDate = new Date().toLocaleString();

  /*
   * Handles a user's cancel request by sending the request to the server and refetching data
   *
   */

  const handleCancel = async () => {
    setHandleCancelReq(true);
    const reqBody = {
      requestActionDto: {
        ctId: cancelReq.ctId,
        datetime: customerDate,
      },
    };
    triggerCancel(reqBody);

    setHandleCancelReq(false);
    trackEvent("Target_Order_Cancel");
    toggleCancelCtSuccess();
    handleClose(false);
  };

  // refetch new data when closing summery
  useEffect(() => {
    if (!cancelSummery) {
      refetchData();
    }
  }, [cancelSummery]);

  if (cancelCtSuccess)
    return (
      <TargetOrderCancelExecuteSummery
        brokerImg={BROKER_IMG}
        brokerName={BROKER_NAME}
        userName={USER_NAME}
        brokerEmail={BROKER_EMAIL}
        open={cancelSummery}
        type={"cancel"}
        toggle={setCancelSummery}
      />
    );
  return (
    <Modal
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "583px",
          height: "290px",
          borderRadius: "10px",
          bgcolor: "background.paper",
          boxShadow: 24,
          [theme.breakpoints.down("md")]: {
            width: "90%",
            height: "auto",
          },
        }}>
        <Typography
          sx={{
            fontSize: "23px",
            fontWeight: 600,
            padding: "24px 24px 11.5px 24px",
          }}>
          {TITLE}
        </Typography>
        <Divider sx={{ marginRight: "24px", marginLeft: "24px" }} />
        <Typography
          id="modal-modal-description"
          sx={{
            mt: 2,
            padding: "0px 24px 12px 24px",
            fontSize: "14px",
            fontWeight: 600,
            color: theme.palette.secondary.main,
          }}>
          Please confirm that you want to request a cancellation for this target.
        </Typography>
        <Typography
          id="modal-modal-description"
          sx={{
            padding: "0 24px 11.5px 24px",
            fontSize: "14px",
            minHeight: "42px",
            textDecoration: "underline",
          }}>
          You are cancelling the below target order:
        </Typography>
        <Typography
          id="modal-modal-description"
          sx={{
            padding: "0 24px 0 24px",
            fontSize: "14px",
            textTransform: "capitalize",
          }}>
          {`${cancelReq.type} ${cancelReq.tradeUnits} units of ${
            cancelReq.currencyTradeCode
          } at ${formatCurrency(cancelReq.targetPrice, cancelReq.currencyConvertCode)}`}
        </Typography>
        <Stack
          spacing={1}
          direction="row"
          sx={{
            width: "100%",
            padding: "24px 24px 0 24px",
            [theme.breakpoints.down("md")]: {
              marginBottom: "15px",
            },
          }}>
          {handleCancelReq && <Typography>Loading</Typography>}
          <Button
            disableRipple
            onClick={() => handleClose(false)}
            sx={{
              textTransform: "capitalize",
              width: "100%",
              backgroundColor: "#f8f9f9",
              border: 0,
              "&: hover": {
                border: 1,
              },
              [theme.breakpoints.down("md")]: {
                height: "30px",
                fontSize: "14px",
              },
            }}
            variant="outlined">
            Go Back
          </Button>
          <Button
            disableRipple
            onClick={handleCancel}
            sx={{
              textTransform: "capitalize",
              boxShadow: "none",
              whiteSpace: " nowrap",
              width: "100%",
              backgroundColor: theme.palette.secondary.main,
              "&: hover": {
                backgroundColor: "#fedbdb",
                opacity: "10",
                boxShadow: "none",
              },
              [theme.breakpoints.down("md")]: {
                height: "30px",
                fontSize: "14px",
              },
            }}
            variant="contained">
            Request cancelation
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default TargetOrderCancel;
